console.log('js/components/customer/forgot-password.js -> v0.1.0');

(() => {
	// The "Forgot your password?" link inside #plt-login-modal relies on
	// data-toggle/data-dismiss to hand off between modals, but that hasn't
	// reliably closed the login modal in practice, so close it explicitly
	// here too (same pattern used in signup.js for signup -> login).
	$('#plt-forgot-password-modal').on('show', function() {
		$('#plt-login-modal').modal('hide');
	});

	const passwordResetEmail = document.querySelector('#password-reset-email');

	if (passwordResetEmail) {
		passwordResetEmail.addEventListener('focusout', function(event) {
			validation.emailValidation(event.target, '.email-validation');
		});
	}


	if(document.querySelector('#forgot-pw-back-button') !== null) {
		var forgotBackButton = document.querySelector('#forgot-pw-back-button');
			forgotBackButton.addEventListener('click', event => {
				const loginStep2 = document.querySelector('.login-step-2');
				const forgotPasswordPane = document.querySelector('#forgot-password-step');
				forgotPasswordPane.classList.add('hide');
				loginStep2.classList.remove('hide');
			});
	}

	$('#plt-forgot-password').submit(function(event){
		event.preventDefault();

		const form = document.querySelector('#plt-forgot-password');

		// set loading state
		const submitButton = form.querySelector('.bttn-submit');
		const errorBlock = form.querySelector('.js-error');
		if(document.querySelector('#forgot-pw-back-button') !== null) {
			var modal = document.querySelector('#forgot-password-step');
			var currentStep = document.querySelector('#forgot-password-step');
			var nextStep = document.querySelector('#forgot-password-success');
			var successBody = document.querySelector('#forgot-password-success');
		}
		else {
		// steps — resolved relative to the form rather than hardcoded to
		// #plt-forgot-password-modal, since this same markup (.steps/.step-1/
		// .step-2) is also rendered standalone on /forgot-password, where
		// that modal doesn't exist and these all used to resolve to null.
			var wrapper = form.closest('.account-form-wrapper');
			var stepsContainer = form.closest('.steps');
			var modal = wrapper;
			var modalBody = wrapper;
			var formBody = stepsContainer.querySelector('.step-1');
			var successBody = stepsContainer.querySelector('.step-2');
		}
		const csrfToken = document.querySelector('#csrfToken').value;

		errorBlock.classList.remove('active');
		submitButton.classList.add('is-loading');

		var request = {
			"email": form.querySelector('#password-reset-email').value
		};

		const params = {
			credentials: 'same-origin',
			method: 'POST',
			body: JSON.stringify(request),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'X-CSRF-Token': csrfToken
			}
		}

		gae('customer','forgot_password_submit');

		fetch("/account/auth/forgot-password", params)
			.then(function(response) {
				return response.json();
			})
			.then(function(response) {

				if (response.status == "error") {
					setTimeout(function() {
						submitButton.classList.remove('is-loading');
						errorBlock.classList.add('active');
						errorBlock.innerHTML = response.error;
					}, 1000);
				}

				if (response.status == "redirect") {
					form.reset();
					window.location.replace(response.redirectUrl);
				}

				if (response.status == "ok") {
					setTimeout(function() {
						submitButton.classList.remove('is-loading');
						modal.scrollTop = 0;
						if(document.querySelector('#forgot-pw-back-button') !== null) {
							currentStep.classList.add('hide');
							nextStep.classList.remove('hide');
						}
						else {
							formBody.classList.add('move-out');
							successBody.classList.add('move-in');
							modalBody.style.height = (successBody.clientHeight + 48) + "px";
							modalBody.style.overflow = 'hidden';
						}


						// set the email as data-email for the resend functionality in the next step
						let emailField = successBody.querySelector('.resend-reset-password-email');
						// (previously scoped to a "#plt-forgot-password-modal ..." descendant
						// selector here, but #plt-forgot-password-modal is an ANCESTOR of
						// successBody, not a descendant, so that could never match — this threw
						// on the next line and skipped the form.reset() below, in the modal too)
						var emailTextPlaceholder = successBody.querySelector('.email-address');
						emailField.setAttribute('data-email', request.email);
						emailTextPlaceholder.innerHTML = request.email;

						form.reset();
					}, 1000);
				}
			})
			.catch(function(error) {
				console.error('Error:', error);
			});
	});
})();
